import FooterFr from 'components/FooterFr'
import MobileFooterFr from 'components/MobileFooterFr'
import MobileNavbarFr from 'components/MobileNavbarFr'
import NavbarFr from 'components/NavbarFr'
// import WorkshopVidsFr from 'components/Seminar/WorkshopVidsFr'
import React from 'react';
import SeminarAllFr from "components/Seminar/SeminarAllFr"
import { useSelector } from "react-redux";
import { useEffect } from "react";

function SeminarsFr() {

  const isMobile = useSelector(state => state.windowSize.isMobile);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <>
    {isMobile ? (
      <>
      <MobileNavbarFr />
      <SeminarAllFr />
      {/* <WorkshopVidsFr /> */}
      <MobileFooterFr />
      </>
    ) : (
      <>
      <NavbarFr />
      <SeminarAllFr />
      {/* <WorkshopVidsFr /> */}
      <FooterFr />
      </>
    )}
    </>
  )
}

export default SeminarsFr